export default "../css/5650cb1f9358bce53d263081de29049f.ttf";